<script lang="ts">
    import { _ } from 'svelte-i18n';

    import src from './svg/delete_FILL0_wght400_GRAD0_opsz24.svg';
    import TemplateIcon from './TemplateIcon.svelte';

    export let scale: number = 1;
    export let hover: string = $_('Remove');
    export let disabled: boolean = false;
</script>

<TemplateIcon {src} {scale} {hover} {disabled} on:click />
